import React, { useContext, useEffect } from 'react';
import './ConfirmationPopup.css';
import cn from "classnames";
import styles from './ConfirmationPopup.module.sass';
import Modal from '@mui/material/Modal';
import Card from '../../../components/Card';
import { GlobalState } from '../../../App';

const ConfirmationPopup = () => {
  const { setIsConfirmUpdateStatus } = useContext(GlobalState)

  useEffect(() => {

    setTimeout(() => {
      setIsConfirmUpdateStatus(false)
    }, 2000);

  }, []);
  return (
    <Modal
      disableAutoFocus={true}
      open={true}
      className='dialog-wrapper'
      sx={{
        outline: '0 !important',
        border: 'none !important'
      }}
    >
      <Card
        className={cn(styles.card)}
        classCardHead={styles.cardHead}
      >
        <div className={styles.buttonsContainer}>
          <h1 className={styles.confirmText}>Status updated successfuly!</h1>
        </div>

      </Card>

    </Modal>

  )
}

export default ConfirmationPopup